export default __webpack_public_path__ + "static/differentiate-headings-do-702e04a6f19cc775f2be4454e02f37c2df45cde6fb839ae105cf72a7423071b5.png";